const o = {
  color: {
    icon: {
      default: "#abb9c7ff",
      hover: "#e09c24ff"
    }
  }
};
export {
  o as emojiPicker
};
